import * as React from 'react';

import { rtlStyle } from 'js/lib/language';

import { LockCircledIcon, SuccessIcon, WarningIcon } from '@coursera/cds-icons';

import { skipFailedStatusForItem } from 'bundles/assess-common/utils/completionStatusUtils';
import GradedPremiumIcon from 'bundles/course-home/page-course-week/components/GradedPremiumIcon';
import ItemIcon from 'bundles/item/components/ItemIcon';
import type { ContentSummary } from 'bundles/learner-progress/types/ContentSummary';
import type { Item } from 'bundles/learner-progress/types/Item';
import { getIsLocked, getIsLockedPGASubmissionPage, getIsLockedPremiumItem } from 'bundles/learner-progress/utils/Item';

import _t from 'i18n!nls/learner-progress';

type Props = {
  computedItem: Item;
  size: number;
  typeNameOverride?: ContentSummary['typeName'];
};

class LearnItemIcon extends React.Component<Props> {
  render() {
    const { computedItem, size, typeNameOverride } = this.props;
    const { id: itemId, courseId } = computedItem;
    const typeName = typeNameOverride || computedItem.contentSummary.typeName;

    const style = rtlStyle({ marginRight: 12 });

    // handle cases where we want to skip failed status and potentially show the item as successful
    // if passed, we want to show the item as successful
    const isFailed = computedItem.isFailed && !skipFailedStatusForItem({ courseId, itemId, itemTypeName: typeName });

    if (isFailed) {
      return (
        <WarningIcon
          title={_t('Warning')}
          color="warning"
          size="large"
          style={style}
          data-testid="learn-item-warning-icon"
        />
      );
    }

    if (computedItem.isCompleted || computedItem.isPassed) {
      return (
        <SuccessIcon
          title={_t('Completed')}
          color="success"
          size="large"
          style={style}
          data-testid="learn-item-success-icon"
        />
      );
    }

    if (getIsLocked(computedItem) || getIsLockedPGASubmissionPage(computedItem)) {
      return (
        <div style={style}>
          {getIsLockedPremiumItem(computedItem) ? (
            <GradedPremiumIcon
              title={_t('Locked')}
              defaultIcon={<LockCircledIcon title={_t('Locked')} size="large" data-testid="lock-icon" />}
              size={size}
            />
          ) : (
            <LockCircledIcon title={_t('Locked')} size="large" data-testid="lock-icon" />
          )}
        </div>
      );
    }

    return <ItemIcon size={size} type={typeName} ariaHidden={true} style={style} useCdsIcon={true} />;
  }
}

export default LearnItemIcon;
